import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataStateChangeEventArgs, DetailRowService, FilterSettingsModel, GridComponent, ReorderService, RowSelectEventArgs, SelectionService, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as pbi from "powerbi-client";
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { batchList, ClearinghouseList, ClientList, CompanyList, EmitBo, EmployeeList, GenerateEmailInvoiceBo, GetClaimsListBO, groupList, MarkServiceAsPaidBO, PayorList, ResubmissionList, SaveBatchFileNewBO, SaveBatchFileNewReturnBOOptimized, ServiceDetailCsvBo, WhereCondition } from '../claims.model';
import { ClaimsListService } from './claims-list.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { ColumnChangeBO, columnWidth } from '../../employee/employee.model';
import { GeneralService } from 'src/app/service/general.service';
import { EnvironmentService } from 'src/app/environment.service';

@Component({
  selector: 'app-claims-list',
  templateUrl: './claims-list.component.html',
  styleUrls: ['./claims-list.component.scss'],
  providers: [DetailRowService, SelectionService, ReorderService],
  encapsulation: ViewEncapsulation.None
})
export class ClaimsListComponent implements OnInit {
  public formatOptions: object;
  claimsAllIdList: any = [];
  public height = '220px';

  isViewbatches: boolean = false;
  initialPage: object;
  isClaimsSelectedId: any = [];
  public exportdatadata: string[] = ['Yes', 'No'];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  isEnabledExcel: boolean = false;
  arraycol: any = [];
  claimids: any;
  @ViewChild('pdflist') pdflist;
  ColumnArray: columnWidth[];
  private onDestroy$: Subject<void> = new Subject<void>();
  viewOptions: EmitBo = new EmitBo();
  FilterBO: GetClaimsListBO = new GetClaimsListBO();
  ListBO: GetClaimsListBO = new GetClaimsListBO();
  public data: Observable<DataStateChangeEventArgs>;
  ResubmissionList: ResubmissionList[];
  public resumissiondropdata: string[];
  filterSettings: FilterSettingsModel;
  type: string = "";
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  is87IClaimBoolean: boolean = false;
  conditionlist: WhereCondition[] = [];
  serviceName: any;
  today = new Date().toLocaleDateString();
  claimstatus: boolean = false;
  generateInvoicedetails: GenerateEmailInvoiceBo = new GenerateEmailInvoiceBo();
  service: any = [];
  ReportHeader: any = "";
  ClaimMasterIds: any = [];
  groupList: groupList[]
  payorList: PayorList[];
  isViewQR: boolean = false;
  employeelists: any=[];
  companyList: CompanyList[];
  clearingHouseList: ClearinghouseList[];
  clientlist: any=[];
  clientlistwithstatus:any=[]

  public dropdata: string[];
  ClaimsDataList: any = [];
  RowClaimMasterId: string;
  batchList: batchList = new batchList();
  claimsSelectedList: any = [];
  public selectionOptions: SelectionSettingsModel;
  @ViewChild('gridClaims') public gridClaims: GridComponent;
  showReady: boolean = false;
  rowSpot: number;
  ReportView: boolean = true;
  isServicelineExport: boolean = false;
  @Input() claimsOptions: EmitBo = new EmitBo();
  @Output() isListOptions = new EventEmitter<EmitBo>();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  selectedGroupName: any;
  CreatedBatchList: SaveBatchFileNewReturnBOOptimized = new SaveBatchFileNewReturnBOOptimized();
  public myDatePickerOptionsheader: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  ReadyJson: any = null;
  ActiveJson: any = null;
  ArchiveJson: any = null;
  Fromdate: any
  PreparedDate: any;
  claimsexportlist: any = []
  MarkServiceAsPaid: MarkServiceAsPaidBO = new MarkServiceAsPaidBO();
  UnderbilledList: any = [];
  isViewUACLetter:boolean=false;
  isClaimAttachmets:boolean=false;
  claimAttachmentIds:any=[];
  UACLetterdata:any;
  ClaimListTotalColumns:number=26;
  constructor(public CommonAPI: CommonApiService,  public global: GlobalComponent, private cdr: ChangeDetectorRef, private datePipe: DatePipe, public toastrService: ToastrService,
    public http: HttpClient, public gethttp: ClaimsListService,
    public general: GeneralService, public dateservice: DateService,
    public Claimslistservice: ClaimsListService, public environmentservice: EnvironmentService) {
    this.global.agencyList();
    this.data = gethttp;
  }

  ngOnInit(): void {
        this.clearGridLocalStorage();
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0 || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.ListBO.dateFilterType = "fromdate";
    this.UnderbilledList = [
      {
        "Key": true,
        "Value": "Yes"
      },
      {
        "Key": false,
        "Value": "No"
      }
    ]
    this.RowClaimMasterId = this.claimsOptions.claimMasterId;
    localStorage.setItem("ac_claimsrowSpot", JSON.stringify(this.RowClaimMasterId));
    if (this.global.isCheckOperationDashboardRecord == true) {
      if (this.global.globalclaimfilter != null) {
        // Tabs
        this.claimsOptions.tabsChanges = this.global.globalCLaimStatus;
        // 837 I or 837 p
        this.is87IClaimBoolean = this.global.globalClaimType;
        this.claimsOptions.is87IClaim = this.global.globalClaimType;
        this.ListBO.is837I = this.claimsOptions.is87IClaim;
        this.FilterBO.is837I = this.claimsOptions.is87IClaim;
        // Claims Status
        this.FilterBO.claimStatus = this.global.globalclaimfilter;
        this.ListBO.claimStatus = this.global.globalclaimfilter;

        if (this.global.isglobalFromorPreparedDate == true) {
          this.ListBO.dateFilterType = "preparedDate";
        }
        else {
          this.ListBO.dateFilterType = "fromdate";
        }


        this.ListBO.filterType = this.global.isglobal30DaysOlder;
      }
    }
    this.selectedGroupName = this.claimsOptions.selectedGroupName;
    if (this.claimsOptions.isClaimsViewEnable) {
      if (this.claimsOptions.ClaimsfilterDetails.groupId != "00000000-0000-0000-0000-000000000000") {
        this.ListBO.groupId =this.claimsOptions.groupIds.toString();
        this.getpayorList();
      }
    }

    this.is87IClaimBoolean = this.claimsOptions.is87IClaim;
    this.ActiveJson = this.claimsOptions.ActiveColumns;
    this.ArchiveJson = this.claimsOptions.ArchiveColumns;
    this.ReadyJson = this.claimsOptions.ReadyColumns;
    this.getResubmissionCode();
    this.getGroupList();
    this.getClearingHouseList();
    this.GetCompanyDropdown();
    this.getemployee();
    this.getClient();

    this.getservice();
    this.getStatusClaim();
    this.filterSettings = { type: 'Menu' };
    this.selectionOptions = {
      checkboxOnly: true
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    //let page = JSON.parse(this.global.globalColumn.column)[0].readyClaims.Pagesize
    let page = 10
    if (!this.claimsOptions.isClaimsViewEnable) {
      this.FilterBO.pageitem = page
      this.initialPage = { currentPage: 1, pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: page }
    }

    else {
      // claimsStatus
      if (this.claimsOptions.claimsStatusData != null) {
        this.ListBO.claimStatus = this.claimsOptions.claimsStatusData;
      }
      // resubmissionLid
      if (this.claimsOptions.ClaimsfilterDetails.resubmissionLid != "00000000-0000-0000-0000-000000000000") {
        this.ListBO.resubmissionLid = this.claimsOptions.ClaimsfilterDetails.resubmissionLid;
      }
      // fromDate
      if (this.claimsOptions.ClaimsfilterDetails.fromDate != null) {
        this.ListBO.fromDate = this.datePipe.transform(this.claimsOptions.ClaimsfilterDetails.fromDate, "MM/dd/yyyy");
      }
      // toDate
      if (this.claimsOptions.ClaimsfilterDetails.toDate != null) {
        this.ListBO.toDate = this.datePipe.transform(this.claimsOptions.ClaimsfilterDetails.toDate, "MM/dd/yyyy");
      }

      // clientId
      if (this.claimsOptions.ClaimsfilterDetails.clientId != "00000000-0000-0000-0000-000000000000") {
          let clientID:any = this.claimsOptions.ClaimsfilterDetails.clientId
          this.ListBO.clientId = clientID.toString();
      }

      // pPClientId
      if (this.claimsOptions.ClaimsfilterDetails.pPClientId != "00000000-0000-0000-0000-000000000000") {
        this.ListBO.pPClientId = this.claimsOptions.ClaimsfilterDetails.pPClientId;
      }


      // employeeId
      if (this.claimsOptions.ClaimsfilterDetails.employeeId != "00000000-0000-0000-0000-000000000000") {
        let employeeID:any = this.claimsOptions.ClaimsfilterDetails.employeeId
        this.ListBO.employeeId = employeeID.toString();
    }

      // companyId
      if (this.claimsOptions.ClaimsfilterDetails.companyId != "00000000-0000-0000-0000-000000000000") {
        this.ListBO.companyId = this.claimsOptions.ClaimsfilterDetails.companyId;
      }
      // // PayerId
      if (this.claimsOptions.PayorIds != "00000000-0000-0000-0000-000000000000") {
        this.ListBO.payerId = this.claimsOptions.PayorIds
      }

      if (this.claimsOptions.masterServiceIds != "00000000-0000-0000-0000-000000000000") {
        this.ListBO.masterServiceId = this.claimsOptions.masterServiceIds;
      }
      this.ListBO.isNeedToReprocessed = this.claimsOptions.ClaimsfilterDetails.isNeedToReprocessed;
      this.FilterBO = this.claimsOptions.ClaimsfilterDetails;
      if (this.claimsOptions.ClaimsfilterDetails.dateFilterType == true) {
        this.ListBO.dateFilterType = "preparedDate"
      }
      else {
        this.ListBO.dateFilterType = "fromdate"

      }
      this.initialPage = { currentPage: this.claimsOptions.ClaimsfilterDetails.currentpageno, pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: page }
    }


    this.getClaimsFilter();

  }
  message: string = 'loading :(';
  ngAfterContentChecked() {
    this.message = 'all done loading :)'
    this.cdr.detectChanges();
  }
  // ...........................................................getGroupList.................................................
  getGroupList() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", "PAYER");
    this.CommonAPI.getDropDownList("PAYER",params, url, "LovDropDown").then((data: any) => {
      this.groupList = data;
      console.log(this.groupList,"this.groupList");
      
      // this.groupList.forEach(element => {
      //   element.label = element.Value,
      //     element.value = element.Key.toString();
      // })
    })
  }
  ///......................................................getservice........................................
  getservice() {
    
    let url = "api/Service/GetServiceDropdown?";
    // let url = "api/Employee/getServicedropdownForPayrates?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.service = data;
      this.service.forEach(element => {
        element.Value = element.Value.toString();
        element.Key = element.Key.toString();
      });

      // masterServiceId
      if (this.claimsOptions.masterServiceIds != null) {
        this.serviceName = this.claimsOptions.masterServiceIds;
        this.ListBO.masterServiceId = this.serviceName.toString();
      }
    })
  }
  //...........................getStatusClaim................................................................
  getStatusClaim() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", 'CLAIMFILTERSTATUS');
    this.CommonAPI.getDropDownList("CLAIMFILTERSTATUS",params, url, "LovDropDown").then((data: any[]) => {
      this.dropdata = data.map(e => e.lovName);
      this.claimstatus = true;
    });
  }
  ///.............................................................setGroupValues..........................................
  setGroupValues(data) {
    this.ListBO.payerId = null;
    let group = this.groupList.filter(gl => gl.id == data)[0];
    if (group == undefined || group == null) {
      this.selectedGroupName = '';
    }
    else {
      this.selectedGroupName = group.lovName.toUpperCase();
    }
    this.batchList.clearingHouseId = ""
    this.ListBO.pPClientId = null
    if (data == undefined || data == "" || data == null) {
      this.ListBO.groupId = null;
      this.ListBO.payerId = null;
      this.payorList = [];
    }
    else {
      this.getpayorList();
    }
    this.Applyfilter();
  }
  //............................................................getpayorList.......................................................
  getpayorList() {

   
    let param = new URLSearchParams();
    let GroupId: string = (this.ListBO.groupId != null && this.ListBO.groupId != undefined) ? this.ListBO.groupId : "00000000-0000-0000-0000-000000000000"
    param.append("groupId", GroupId.toString());
    let url = "api/Payer/getpayerId?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.payorList = data;
      this.payorList.forEach(element => {
        element.label = element.label,
          element.value = element.value.toString();

      })
      // // PayerId
      if (this.claimsOptions.PayorIds != null && this.claimsOptions.PayorIds != "00000000-0000-0000-0000-000000000000") {
        this.ListBO.payerId = this.claimsOptions.PayorIds;
      }
    })
  }
  //..............................................................setPayerValues........................................
  setPayerValues(data) {
    if (data == undefined) {
      this.ListBO.payerId = null;
    }
  }
  ///.................................................getemployee.......................................................
  getemployee() {
    let param = new URLSearchParams();

    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId =this.global.globalLocationId;
    }
    else {
      locId =  "00000000-0000-0000-0000-000000000000";
    }
    param.append("LocationId", locId);
    let url = "api/Client/GetEmpListbyId?" 
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
      this.employeelists = JSON.parse(JSON.stringify(data));
      this.employeelists.forEach((employeeeRecords) => {
        employeeeRecords.id = employeeeRecords.id.toString();
        employeeeRecords.names =
        employeeeRecords.names +
          " (" +
          employeeeRecords.status + ")"
      });


    })
  }
  ///.................................................getClient.......................................................
  getClient() {
    let param = new URLSearchParams();

    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId = this.global.globalLocationId;
    }
    else {
      locId =  "00000000-0000-0000-0000-000000000000";
    }
    let url = "api/Client/GetCommonClientListByAgency?" 
    param.append("LocationId", locId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: ClientList[]) => {
      this.clientlist=data;
      console.log(data)
      this.clientlistwithstatus = data;
      this.clientlist.forEach((clientRecords) => {
        clientRecords.id = clientRecords.id.toString();
        clientRecords.names =
        clientRecords.names +
          " (" +
          clientRecords.status + ")";
          if(clientRecords.medicaid)
            clientRecords.names+= " ( "+ clientRecords.medicaid + " ) ";
      });


    })
  }
  ///.................................................getClearingHouseList.......................................................
  getClearingHouseList() {
    let url = "api/ClearingHouse/getCommonClearingHouselist?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: ClearinghouseList[]) => {
      this.clearingHouseList = data;
      this.clearingHouseList.forEach(element => {
        element.label = element.Value;
        element.value = element.Key;
      })
    },
     )
  }
  ///.................................................GetCompanyDropdown.......................................................
  GetCompanyDropdown() {
    let url = "api/Company/GetCompanyDropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: ClearinghouseList[]) => {
      this.companyList = data;
      this.companyList.forEach(element => {
        element.label = element.Value;
        element.value = element.Key.toString();
      })
    },
      )
  }

  //.................................. onResizeClaims..................................
  onResizeClaims(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.gridClaims.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  // ..................................SaveColumnwidth..................................
  SaveColumnwidth() {

    if (this.claimsOptions.tabsChanges == 'ReadyClaims') {
      this.arraycol[0].readyClaims.Columns = this.ColumnArray;
      this.arraycol[0].readyClaims.Pagesize = this.gridClaims.pageSettings.pageSize;
    }
    //  for Active
    else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
      this.arraycol[0].ActiveClaims.Columns = this.ColumnArray;
      this.arraycol[0].ActiveClaims.Pagesize = this.gridClaims.pageSettings.pageSize;
    }
    //  for Archive
    else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {
      this.arraycol[0].ArchiveClaims.Columns = this.ColumnArray;
      this.arraycol[0].ArchiveClaims.Pagesize = this.gridClaims.pageSettings.pageSize;
    }

    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //  this.getColumnwidth();
    });
  }
  //.............................................. openColumnChooser..................................
  show() {
    this.gridClaims.columnChooserModule.openColumnChooser(200, 50);
  }
  //.................................. getColumnwidth..................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    if (this.claimsOptions.tabsChanges == 'ReadyClaims') {
      this.ColumnArray = this.arraycol[0].readyClaims.Columns;
      let hideReadytoBillcolumns = this.arraycol[0].readyClaims.HideColumns

      this.gridClaims.hideColumns(hideReadytoBillcolumns);
    }
    //  for Active
    else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
      this.ColumnArray = this.arraycol[0].ActiveClaims.Columns;
      let hideActivecolumns = this.arraycol[0].ActiveClaims.HideColumns

      this.gridClaims.hideColumns(hideActivecolumns);
    }
    //  for Archive
    else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {
      this.ColumnArray = this.arraycol[0].ArchiveClaims.Columns;
      let hideArchivecolumns = this.arraycol[0].ArchiveClaims.HideColumns

      this.gridClaims.hideColumns(hideArchivecolumns);
    }
    if (this.gridClaims != undefined) {
      if (this.claimsOptions.tabsChanges == 'ReadyClaims') {
        this.gridClaims.pageSettings.pageSize = this.arraycol[0].readyClaims.Pagesize;

      }
      //  for Active
      else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
        this.gridClaims.pageSettings.pageSize = this.arraycol[0].ActiveClaims.Pagesize;

      }
      //  for Archive
      else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {
        this.gridClaims.pageSettings.pageSize = this.arraycol[0].ArchiveClaims.Pagesize;

      }
      this.ColumnArray.forEach(element => {
        // checkbox
        if (element.column == '') {
          const column1 = this.gridClaims.getColumnByUid('checkbox');
          column1.headerText = element.column;
          column1.width = element.width;
          this.gridClaims.refreshHeader();
        }
        //Batch No
        if (element.column == 'Batch No' && this.claimsOptions.tabsChanges != 'ReadyClaims') {
          const column = this.gridClaims.getColumnByField('batchNumbers');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Status
        if (element.column == 'Status' && this.claimsOptions.tabsChanges != 'ReadyClaims') {
          const column = this.gridClaims.getColumnByField('claimStatus');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Resubmission
        if (element.column == 'Resubmission' && this.claimsOptions.tabsChanges != 'ReadyClaims') {
          const column = this.gridClaims.getColumnByField('resubmission');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Exported
        if (element.column == 'Exported' && this.claimsOptions.tabsChanges != 'ReadyClaims') {
          const column = this.gridClaims.getColumnByField('exported');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Client
        if (element.column == 'Client') {
          const column = this.gridClaims.getColumnByField('clientName');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Prepared Date
        if (element.column == 'Prepared Date') {
          const column1 = this.gridClaims.getColumnByField('preparedDate');
          column1.headerText = element.column;
          column1.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Payor
        if (element.column == 'Payor') {
          const column2 = this.gridClaims.getColumnByField('payerName');
          column2.headerText = element.column;
          column2.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // From Date
        if (element.column == 'From Date') {
          const column3 = this.gridClaims.getColumnByField('fromDate');
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridClaims.refreshHeader();
        }

        // To Date
        if (element.column == 'To Date') {
          const column3 = this.gridClaims.getColumnByField('toDate');
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Company
        if (element.column == 'Company') {
          const column3 = this.gridClaims.getColumnByField('company');
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridClaims.refreshHeader();
        }
        //Total Gross Amt..
        if (element.column == 'Total Gross Charge') {
          const column = this.gridClaims.getColumnByField('grossCharge');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Total Amt.
        if (element.column == 'Total Amt.') {
          const column = this.gridClaims.getColumnByField('totalCharge');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        //Paid Amt.
        if (element.column == 'Paid Amt.') {
          const column = this.gridClaims.getColumnByField('paidAmount');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        //Note.
        if (element.column == 'Note') {
          const column = this.gridClaims.getColumnByField('note');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        //Claim Id
        if (element.column == 'Claim Id') {
          const column = this.gridClaims.getColumnByField('id');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // SpendDownCharge
        if (element.column == 'SpendDownCharge') {
          const column = this.gridClaims.getColumnByField('spendDownCharge');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // spendDownPaid
        if (element.column == 'SpendDownPaid') {
          const column = this.gridClaims.getColumnByField('spendDownPaid');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        //Patient Control Number
        if (element.column == 'Patient Control Number') {
          const column = this.gridClaims.getColumnByField('patientControlNumbers');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Balance Due
        if (element.column == 'Balance Due') {
          const column = this.gridClaims.getColumnByField('balanceAmount');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Location
        if (element.column == 'Location') {
          const column = this.gridClaims.getColumnByField('clientLocation');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Phone
        if (element.column == 'Phone') {
          const column = this.gridClaims.getColumnByField('clientPhone');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // Action
        if (element.column == 'Action') {
          const column1 = this.gridClaims.getColumnByUid('action');
          column1.headerText = 'Action';
          column1.width = element.width;
          this.gridClaims.refreshHeader();
        }
        // claimMaster_Status
        if (element.column == 'Alter Claim Status') {
          const column = this.gridClaims.getColumnByField('claimMaster_Status');
          column.headerText = element.column;
          column.width = element.width;
          this.gridClaims.refreshHeader();
        }
        
      
      });
    }
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    if (this.claimsOptions.tabsChanges == 'ReadyClaims') {
      this.gridClaims.hideColumns("UnderBilled");
    }
    else {
      this.gridClaims.showColumns("UnderBilled");
    }
  }
  refreshToGetDropDownValues(ListCode: string) {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode,params, url, "LovDropDown").then((data: any) => {
      if (ListCode == 'RESUBMISSION') {
        this.ResubmissionList = data;
        this.resumissiondropdata = data.map(r => r.Value);
      }
      if (ListCode == 'CLAIMFILTERSTATUS') {
        this.dropdata = data.map(e => e.Value);
        this.claimstatus = true;
      }
      if (ListCode == 'PAYER') {
        this.groupList = data;
        this.groupList.forEach(element => {
          // element.label = element.Value,
          //   element.value = element.Key.toString();
        })
      }
    })
  }
  //................................... getResubmissionCode....................................................................
  getResubmissionCode() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "RESUBMISSION");
    this.CommonAPI.getDropDownList('RESUBMISSION',params, url, "LovDropDown").then((data: ResubmissionList[]) => {
      this.ResubmissionList = data;
      this.resumissiondropdata = data.map(r => r.Value);
    })
  }
  //.........................................................Checkbox change .......................
  checkBoxChange(args) {
    this.claimsexportlist = []
    this.isClaimsSelectedId = [];
    this.ClaimMasterIds = []
    if (args.checked && args.target.classList.contains('e-checkselectall')) {
      this.isClaimsSelectedId = [];
      this.ClaimMasterIds = [];
      this.ClaimMasterIds = this.claimsAllIdList;  
      this.isClaimAttachmets= this.ClaimsDataList?.some(items => items.isClaimAttachment);
      this.claimAttachmentIds=this.ClaimsDataList?.filter(data=>data.isClaimAttachment).map(item=>item.id);

      this.claimsSelectedList.forEach(claims => {
        this.isClaimsSelectedId.push(claims.id);
        this.claimsexportlist.push(
          {
            claimMasterId: claims.id,
            preparedDate: claims.preparedDate
          }
        )
      });
    }
    else if (args.target.classList.contains('e-checkselect')) {
      var rows: any = this.gridClaims.getSelectedRecords();
      this.isClaimsSelectedId = rows.filter(t => t.clientName != undefined && t.clientName != null && t.clientName != '').map(d => d.id);
      this.ClaimMasterIds = rows.filter(t => t.clientName != undefined && t.clientName != null && t.clientName != '').map(d => d.id);
      let exportlist = rows.filter(t => t.clientName != undefined && t.clientName != null && t.clientName != '').map(item => item);
      this.isClaimAttachmets= rows?.some(items => items.isClaimAttachment);
      this.claimAttachmentIds=rows?.filter(data=>data.isClaimAttachment).map(item=>item.id);
      exportlist.forEach(claims => {
        this.claimsexportlist.push(
          {
            claimMasterId: claims.id,
            preparedDate: claims.preparedDate
          }
        )
      });



      let result = this.gridClaims.getRowInfo(args.target)
    }

  }
  ///.............................................onActionComplete.............................................
  public onActionComplete(args) {

    if (this.claimsOptions.tabsChanges == 'ReadyClaims') {
      if (args.requestType == "columnstate") {
        let hidearr = [];
        let showarr = [];
        this.gridClaims.columns.forEach(element => {
          if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
            hidearr.push(element.headerText);
          }
          if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
            showarr.push(element.headerText);
          }
        })
        var count = 0;
        var count1 = 0;
        if (args.columns.length > 0) {
          if (this.arraycol.length > 0) {
            this.arraycol[0].readyClaims.ShowColumns.forEach(old => {
              showarr.forEach(element => {
                if (old == element) {
                  count1 = count1 + 1;
                }
              });
            });
            this.arraycol[0].readyClaims.HideColumns.forEach(old => {
              hidearr.forEach(element => {
                if (old == element) {
                  count = count + 1;
                }
              });
            });
            if (this.arraycol[0].readyClaims.ShowColumns.length != count1 || this.arraycol[0].readyClaims.HideColumns.length != count) {
              this.arraycol[0].readyClaims.ShowColumns = showarr;
              this.arraycol[0].readyClaims.HideColumns = hidearr;
              this.SaveColumnwidth();
            }
          }
        }
      }
      this.FilterBO.currentpageno = this.gridClaims.pagerModule.pagerObj.currentPage;
      this.FilterBO.pageitem = this.gridClaims.pagerModule.pagerObj.pageSize;
      this.conditionlist = [];
      if (args.requestType === "filtering" && args.action === "filter") {
        args.columns.forEach(element => {
          this.conditionlist.push(element.properties);
        });
      }
      if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
        this.FilterBO.type = args.columnType
      }
    }
    else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
      if (args.requestType == "columnstate") {
        let hidearr = [];
        let showarr = [];
        this.gridClaims.columns.forEach(element => {
          if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
            hidearr.push(element.headerText);
          }
          if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
            showarr.push(element.headerText);
          }
        })
        var count = 0;
        var count1 = 0;
        if (args.columns.length > 0) {
          if (this.arraycol.length > 0) {
            this.arraycol[0].ActiveClaims.ShowColumns.forEach(old => {
              showarr.forEach(element => {
                if (old == element) {
                  count1 = count1 + 1;
                }
              });
            });
            this.arraycol[0].ActiveClaims.HideColumns.forEach(old => {
              hidearr.forEach(element => {
                if (old == element) {
                  count = count + 1;
                }
              });
            });
            if (this.arraycol[0].ActiveClaims.ShowColumns.length != count1 || this.arraycol[0].ActiveClaims.HideColumns.length != count) {
              this.arraycol[0].ActiveClaims.ShowColumns = showarr;
              this.arraycol[0].ActiveClaims.HideColumns = hidearr;
              this.SaveColumnwidth();
            }
          }
        }
      }
      this.FilterBO.currentpageno = this.gridClaims.pagerModule.pagerObj.currentPage;
      this.FilterBO.pageitem = this.gridClaims.pagerModule.pagerObj.pageSize;
      this.conditionlist = [];
      if (args.requestType === "filtering" && args.action === "filter") {
        args.columns.forEach(element => {
          this.conditionlist.push(element.properties);
        });
      }
      if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
        this.FilterBO.type = args.columnType
      }
    }
    else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {
      if (args.requestType == "columnstate") {
        let hidearr = [];
        let showarr = [];
        this.gridClaims.columns.forEach(element => {
          if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
            hidearr.push(element.headerText);
          }
          if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
            showarr.push(element.headerText);
          }
        })
        var count = 0;
        var count1 = 0;
        if (args.columns.length > 0) {
          if (this.arraycol.length > 0) {
            this.arraycol[0].ArchiveClaims.ShowColumns.forEach(old => {
              showarr.forEach(element => {
                if (old == element) {
                  count1 = count1 + 1;
                }
              });
            });
            this.arraycol[0].ArchiveClaims.HideColumns.forEach(old => {
              hidearr.forEach(element => {
                if (old == element) {
                  count = count + 1;
                }
              });
            });
            if (this.arraycol[0].ArchiveClaims.ShowColumns.length != count1 || this.arraycol[0].ArchiveClaims.HideColumns.length != count) {
              this.arraycol[0].ArchiveClaims.ShowColumns = showarr;
              this.arraycol[0].ArchiveClaims.HideColumns = hidearr;
              this.SaveColumnwidth();
            }
          }
        }
      }
      this.FilterBO.currentpageno = this.gridClaims.pagerModule.pagerObj.currentPage;
      this.FilterBO.pageitem = this.gridClaims.pagerModule.pagerObj.pageSize;
      this.conditionlist = [];
      if (args.requestType === "filtering" && args.action === "filter") {
        args.columns.forEach(element => {
          this.conditionlist.push(element.properties);
        });
      }
      if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
        this.FilterBO.type = args.columnType
      }
    }
  }
  //................................................... dataStateChange.................................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.FilterBO.orderColumn = state.sorted[0].name;
        this.FilterBO.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.FilterBO.field = state.action.currentFilterObject.field;
      this.FilterBO.matchCase = state.action.currentFilterObject.matchCase;
      this.FilterBO.operator = state.action.currentFilterObject.operator;
      this.FilterBO.value = state.action.currentFilterObject.value;
      if (this.FilterBO.type == "number") {
        this.FilterBO.value = state.action.currentFilterObject.value.toString();
        this.FilterBO.field = state.action.currentFilterObject.field;
      }
      else if (this.FilterBO.type == "date") {
        this.FilterBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.FilterBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.FilterBO.value = state.action.currentFilterObject.value;
        this.FilterBO.field = state.action.currentFilterObject.field;
      }
      this.FilterBO.matchCase = state.action.currentFilterObject.matchCase;
      this.FilterBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.FilterBO.field = "ClientName";
        this.FilterBO.matchCase = false;
        this.FilterBO.operator = "startswith";
        this.FilterBO.value = "";
        this.FilterBO.type = "string";
      }
    }
    if (this.type != "refresh") {
      this.getClaimsFilter();
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        //ReadyClaims Array Columns
        if (this.claimsOptions.tabsChanges == 'ReadyClaims') {
          if (this.arraycol[0].readyClaims.Pagesize != state.take) {
            this.arraycol[0].readyClaims.Pagesize = state.take
          }
        }
        //Active Array Columns 
        else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
          if (this.arraycol[0].ActiveClaims.Pagesize != state.take) {
            this.arraycol[0].ActiveClaims.Pagesize = state.take
          }
        }
        //Archive Array Columns
        else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {
          if (this.arraycol[0].ArchiveClaims.Pagesize != state.take) {
            this.arraycol[0].ArchiveClaims.Pagesize = state.take

          }

        }
        this.SaveColumnwidth();
      }
    }
  }
  rowSelected(args: RowSelectEventArgs) {
    const selectedrowindex: number[] = this.gridClaims.getSelectedRowIndexes();  // Get the selected row indexes.
    const selectedrecords: object[] = this.gridClaims.getSelectedRecords();  // Get the selected records.
    var rows: any = this.gridClaims.getSelectedRecords();
    this.isClaimsSelectedId = rows.filter(t => t.clientName != undefined && t.clientName != null && t.clientName != '').map(d => d.id);
    this.ClaimMasterIds = rows.filter(t => t.clientName != undefined && t.clientName != null && t.clientName != '').map(d => d.id);




    // this.gridClaims.getPersistData();

    // let selectedrows = this.gridClaims.getPersistData();
    // let rowindex = JSON.parse((selectedrows));


  }
  // ...................................................createBatchDetailsFile.............................................................
  createBatchDetailsFile() {
    if (this.ListBO.groupId ==  "00000000-0000-0000-0000-000000000000" || this.ListBO.groupId == null || this.ListBO.groupId == undefined) {
      this.toastrService.error(" Please select the Group");
      return;
    }

    this.global.loading = true;
    this.CreatedBatchList = new SaveBatchFileNewReturnBOOptimized();
    let obj = new SaveBatchFileNewBO();
    obj = {
      groupLid: (this.ListBO.groupId != null && this.ListBO.groupId != undefined) ?
       this.ListBO.groupId.toString() :"00000000-0000-0000-0000-000000000000",
      clearingHouseId: this.batchList.clearingHouseId,
      claimMaterId: this.ClaimMasterIds
    }
    // ClaimMasterIds

    let url = "api/ClaimProcess/SaveBatchFile";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(obj, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: SaveBatchFileNewReturnBOOptimized) => {
      this.isClaimsSelectedId = [];
      this.ClaimMasterIds = [];
      this.CreatedBatchList = data;

      this.global.loading = false;
      this.getClaimsFilter();
      this.toastrService.success('Batch generated successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      document.getElementById('spancreatebatch').click();
      if(this.isClaimAttachmets){
        this.getClaimAttachmentDetails();
      }
    },
      (err: any) => {
        var a: any = err;
        if (err.error == undefined || err.error == null || err.error == "") {
          this.toastrService.error(a, 'error');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
        else {
          this.toastrService.error(err.error, 'error');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      })
  }
  //.....................................................ActivecreateBatchFile.............................................
  ActivecreateBatchFile() {

    if (this.ListBO.groupId == "00000000-0000-0000-0000-000000000000" || this.ListBO.groupId == null || this.ListBO.groupId == undefined) {
      this.toastrService.error("Please select the Group");
      return;
    }
    let count = 0;

    this.isClaimsSelectedId.forEach(element => {
      let val = this.claimsSelectedList.filter(c => c.id == element);
      if (val[0].isExported == true) {
        count++;
      }
    });
    if (count > 0) {
      this.toastrService.error('Claim Already Exported');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    }
    else { this.createBatchDetailsFile() }
  }
  // ..........................................................downloadFile..............................................
  downloadFile(data) {
    if (data != null) {
      window.open(data);
    }
    else {
    }
  }
  //...................................................kendopdfdownloadList.......................................................................
  kendopdfdownloadList() {
    this.pdflist.A4 = true,
      this.pdflist.portrait = true,
      this.pdflist.keepTogether = ".prevent-split",
      this.pdflist.scale = 0.8,
      this.pdflist.height = 100,
      this.pdflist.margin = { left: "0.2cm", top: "1cm", right: "0.6cm", bottom: "1cm", }
    this.pdflist.padding = { bottom: "50px" };
    this.pdflist.forcePageBreak = ".page-header"
    this.pdflist.saveAs("837Report" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  }
  //....................................................viewbatchFileclose...............................................
  viewbatchFileclose() {
    document.getElementById("OpenviewbatchFile").click();
  }
  //.......................................................switchchange......................................................
  switchchange() {
    this.claimsOptions.claimMasterId = "00000000-0000-0000-0000-000000000000";
    this.RowClaimMasterId = "00000000-0000-0000-0000-000000000000";
    this.FilterBO.is837I = this.is87IClaimBoolean;
    this.claimsOptions.is87IClaim = this.is87IClaimBoolean;
    this.ListBO.masterServiceId = null;
    this.getClaimsFilter();
  }
  //........................................................Applyfilter............................................
  Applyfilter() {
    this.getClaimsFilter();
  }
  ///.................................................tabchange.......................................................
  tabchange(value) {

    this.claimsOptions.claimMasterId = "00000000-0000-0000-0000-000000000000";

    this.claimsOptions.tabsChanges = value;
    if (this.claimsOptions.tabsChanges == 'ReadyClaims') {

      // let claimsReadyShowColumns = this.arraycol[0].readyClaims.ShowColumns;
      // let claimsReadyHideColumns = this.arraycol[0].readyClaims.HideColumns;
      // this.gridClaims.showColumns(claimsReadyShowColumns);
      // this.gridClaims.hideColumns(claimsReadyHideColumns);
      // this.gridClaims.showColumns(['SpendDownCharge', 'SpendDownPaid']);
      // this.gridClaims.hideColumns(['Batch No', 'Status', 'Resubmission', 'Exported']);
    }
    else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
      // let claimsActiveshowColumns = this.arraycol[0].ActiveClaims.ShowColumns;
      // let claimsActiveHideColumns = this.arraycol[0].ActiveClaims.HideColumns;
      // this.gridClaims.showColumns(claimsActiveshowColumns);
      // this.gridClaims.hideColumns(claimsActiveHideColumns);
      // this.gridClaims.hideColumns(['SpendDownCharge', 'SpendDownPaid']);
    }
    else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {
      // let claimsArchiveShowColumns = this.arraycol[0].ArchiveClaims.ShowColumns;
      // let claimsArchiveHideColumns = this.arraycol[0].ArchiveClaims.HideColumns;
      // this.gridClaims.showColumns(claimsArchiveShowColumns);
      // this.gridClaims.hideColumns(claimsArchiveHideColumns);
      // this.gridClaims.hideColumns(['SpendDownCharge', 'SpendDownPaid']);
    }

    if (this.claimsOptions.tabsChanges == "ReadyClaims") {
      if (this.ReadyJson == null) {
        this.FilterBO.currentpageno = 1;
        this.gridClaims.pageSettings.currentPage = JSON.parse(JSON.stringify(this.FilterBO)).currentpageno;
      }
      else {
        this.gridClaims.pageSettings.currentPage = JSON.parse(JSON.stringify(this.ReadyJson)).currentpageno;
        this.FilterBO.currentpageno = this.ReadyJson.currentpageno;
      }
      // this.gridClaims.clearFiltering();
      // this.gridClaims.clearSorting();
    }
    else if (this.claimsOptions.tabsChanges == "ActiveClaims") {

      if (this.ActiveJson == null) {
        this.FilterBO.currentpageno = 1;
        this.gridClaims.pageSettings.currentPage = JSON.parse(JSON.stringify(this.FilterBO)).currentpageno;
      }
      else {
        this.gridClaims.pageSettings.currentPage = JSON.parse(JSON.stringify(this.ActiveJson)).currentpageno;
        this.FilterBO.currentpageno = this.ActiveJson.currentpageno;
      }
      // this.gridClaims.clearFiltering();
      // this.gridClaims.clearSorting();
      // this.ListBO.isNeedToReprocessed=null;

      this.ListBO.isNeedToReprocessed = false;
    }
    else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {

      if (this.ArchiveJson == null) {
        this.FilterBO.currentpageno = 1;
        this.gridClaims.pageSettings.currentPage = JSON.parse(JSON.stringify(this.FilterBO)).currentpageno;
      }
      else {
        this.gridClaims.pageSettings.currentPage = JSON.parse(JSON.stringify(this.ArchiveJson)).currentpageno;
        this.FilterBO.currentpageno = this.ArchiveJson.currentpageno;
      }
      // this.gridClaims.clearFiltering();
      // this.gridClaims.clearSorting();
      // this.ListBO.isNeedToReprocessed=null;
      this.ListBO.isNeedToReprocessed = false;
    }
    this.FilterBO.type = "string";
    this.getClaimsFilter();
  }
  // ..................................getClaimsFilter..................................
  getClaimsFilter() {
    this.claimsSelectedList = [];
    this.isClaimsSelectedId = [];
    this.ClaimMasterIds = [];
    let tomorrow = new Date(new Date(new Date().setHours(0, 0, 0, 0)).setDate(new Date().getDate() + 1));
    // if ((this.ListBO.fromDate == null || this.ListBO.fromDate == '' || this.ListBO.fromDate == undefined) &&
    //   this.ListBO.toDate != null && this.ListBO.toDate != '' && this.ListBO.toDate != undefined) {
    //   this.toastrService.error("Please select from date")
    //   return;
    // }
    if (this.ListBO.fromDate != null && this.ListBO.fromDate != '' && this.ListBO.fromDate != undefined && this.ListBO.toDate != null && this.ListBO.toDate != '' && this.ListBO.toDate != undefined) {
      if (new Date(this.ListBO.fromDate).getTime() >= tomorrow.getTime() || new Date(this.ListBO.toDate).getTime() >= tomorrow.getTime()) {
        this.toastrService.error('From and To Date can not be a Future Date');
        return;
      }
      if (new Date(this.ListBO.fromDate).getTime() > new Date(this.ListBO.toDate).getTime()) {
        this.toastrService.error("To date should greater than start date")
        return;
      }
    }
    this.FilterBO.isNeedToReprocessed = this.ListBO.isNeedToReprocessed;
    if (this.global.globalclaimfilter != null) {
      {

        this.ListBO.fromDate = this.datePipe.transform(this.global.claimsFromDate, "MM/dd/yyyy");
        this.ListBO.toDate = this.datePipe.transform(this.global.claimsToDate, "MM/dd/yyyy");

      }
    }

    this.FilterBO.fromDate = ((this.ListBO.fromDate != '' && this.ListBO.fromDate != null) && this.ListBO.fromDate != undefined) ?
      this.global.getDateTimeString(this.ListBO.fromDate) : null;
    this.FilterBO.toDate = ((this.ListBO.toDate != '' && this.ListBO.toDate != null) && this.ListBO.toDate != undefined) ?
      this.global.getDateTimeString(this.ListBO.toDate) : null;
    this.FilterBO.employeeId = (this.ListBO.employeeId != null && this.ListBO.employeeId != undefined && this.ListBO.employeeId != "" && this.ListBO.employeeId !="00000000-0000-0000-0000-000000000000") ? this.ListBO.employeeId : "00000000-0000-0000-0000-000000000000";
    this.FilterBO.pPClientId = (this.ListBO.pPClientId != null && this.ListBO.pPClientId != undefined && this.ListBO.pPClientId != "" && this.ListBO.pPClientId !="00000000-0000-0000-0000-000000000000") ? this.ListBO.pPClientId : "00000000-0000-0000-0000-000000000000";
    this.FilterBO.clientId = (this.ListBO.clientId != null && this.ListBO.clientId != undefined && this.ListBO.clientId !="" && this.ListBO.clientId !="00000000-0000-0000-0000-000000000000") ? this.ListBO.clientId : "00000000-0000-0000-0000-000000000000";
    this.FilterBO.groupId = (this.ListBO.groupId != null && this.ListBO.groupId != undefined && this.ListBO.groupId != "" && this.ListBO.groupId !="00000000-0000-0000-0000-000000000000") ? this.ListBO.groupId : "00000000-0000-0000-0000-000000000000";
    this.FilterBO.payerId = (this.ListBO.payerId != null && this.ListBO.payerId != undefined && this.ListBO.payerId != "" &&this.ListBO.payerId !="00000000-0000-0000-0000-000000000000") ? this.ListBO.payerId : "00000000-0000-0000-0000-000000000000";
    this.FilterBO.claimStatus = (this.ListBO.claimStatus != null && this.ListBO.claimStatus != undefined) ? this.ListBO.claimStatus : "";
    this.FilterBO.masterServiceId = (this.ListBO.masterServiceId != null && this.ListBO.masterServiceId != undefined && this.ListBO.masterServiceId !="00000000-0000-0000-0000-000000000000") ? this.ListBO.masterServiceId : "00000000-0000-0000-0000-000000000000";
    this.FilterBO.underbilled = this.ListBO.underbilled
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      this.FilterBO.locationID = this.global.globalLocationId;
    }
    this.FilterBO.companyId = (this.ListBO.companyId != null && this.ListBO.companyId != undefined && this.ListBO.companyId != "00000000-0000-0000-0000-000000000000") ? this.ListBO.companyId : "00000000-0000-0000-0000-000000000000";
    this.FilterBO.resubmissionLid = (this.ListBO.resubmissionLid != null && this.ListBO.resubmissionLid != undefined && this.ListBO.resubmissionLid !="00000000-0000-0000-0000-000000000000") ? this.ListBO.resubmissionLid : "00000000-0000-0000-0000-000000000000";
    setTimeout(() => {
      if (this.claimsOptions.tabsChanges == "ReadyClaims") {
        this.FilterBO.claimCategory = "READYTOBILL";
        this.FilterBO.pageitem = this.gridClaims.pageSettings.pageSize;
        // this.FilterBO.currentpageno = this.ReadyJson.currentpageno
        this.ReadyJson = JSON.parse(JSON.stringify(this.FilterBO));
      }
      else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
        this.FilterBO.claimCategory = "ACTIVE";
        this.FilterBO.pageitem = this.gridClaims.pageSettings.pageSize;
        // this.FilterBO.currentpageno = this.ActiveJson.currentpageno
        this.ActiveJson = JSON.parse(JSON.stringify(this.FilterBO));
      }
      else if (this.claimsOptions.tabsChanges == "ArchiveClaims") {
        this.FilterBO.claimCategory = "ARCHIVE";
        this.FilterBO.pageitem = this.gridClaims.pageSettings.pageSize;
        // this.FilterBO.currentpageno = this.ArchiveJson.currentpageno
        this.ArchiveJson = JSON.parse(JSON.stringify(this.FilterBO));
      }
      this.FilterBO.filterType = this.ListBO.filterType;
      this.FilterBO.dateFilterType = (this.ListBO.dateFilterType == "fromdate") ? false : true;
      this.gethttp.outputValues(this.FilterBO);
    }, 300);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClaimsDataList = data.result;
      this.claimsSelectedList = data.result;
      this.claimsAllIdList = data.idList;
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
       // this.getColumnwidth();
      }
      if ((data != null && data.result.length > 0)) {
        this.isEnabledExcel = true;
      }
      else {
        this.isEnabledExcel = false;
      }
      if (data != null && data.result.length >= 15) {
        this.gridClaims.height = "500";
      } else {
        this.gridClaims.height = "auto";
      }
      let claimsrowid = JSON.parse(localStorage.getItem("ac_claimsrowSpot"));

      if (claimsrowid == 0 || claimsrowid == undefined || claimsrowid == null || claimsrowid == "") {

        this.gridClaims.selectedRowIndex = -1;
      }
      else {

        // data?.result?.forEach(claimsarray => {


        // // if (claimsarray.id == a) {

        let index = this.ClaimsDataList.findIndex(rowSpotIndex => rowSpotIndex.id == claimsrowid);
        this.rowSpot = parseInt(index.toString());
        this.gridClaims.selectedRowIndex = this.rowSpot;
        // }
        // });
      }

    })
  }
  //......................................exportClaimsWithPaginationCsv.....................................................
  exportClaimsWithPaginationCsv() {
    if (this.claimsOptions.tabsChanges == "ReadyClaims") {
      this.FilterBO.claimCategory = "READYTOBILL";
      this.FilterBO.pageitem = this.gridClaims.pageSettings.pageSize;
      this.FilterBO.currentpageno = this.gridClaims.pageSettings.currentPage;
    }
    else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
      this.FilterBO.claimCategory = "ACTIVE";
      this.FilterBO.pageitem = this.gridClaims.pageSettings.pageSize;
      this.FilterBO.currentpageno = this.gridClaims.pageSettings.currentPage;
    }
    else {
      this.FilterBO.claimCategory = "ARCHIVE";
      this.FilterBO.pageitem = this.gridClaims.pageSettings.pageSize;
      this.FilterBO.currentpageno = this.gridClaims.pageSettings.currentPage;
    }
    if (!this.isServicelineExport) {
      let url = "api/ClaimMaster/exportClaimsWithPaginationCsv";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.FilterBO, url, "ClaimsReport.csv");
    }
    
    else {
      let url = "api/ClaimMaster/exportServiceLinesWithPaginationCsv";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.FilterBO, url, "ClaimsServiceLineReport.csv");
    }
  }
  //...........................................exportClaimsCsv................................................................
  exportClaimsCsv() {
    if (this.claimsOptions.tabsChanges == "ReadyClaims") {
      this.FilterBO.claimCategory = "READYTOBILL";
    }
    else if (this.claimsOptions.tabsChanges == "ActiveClaims") {
      this.FilterBO.claimCategory = "ACTIVE";
    }
    else {
      this.FilterBO.claimCategory = "ARCHIVE";
    }
    if (!this.isServicelineExport) {
      let url = "api/ClaimMaster/exportClaimsCsv";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.FilterBO, url, "ClaimsReport.csv")
    }
    else {
      let url = "api/ClaimMaster/exportServiceLines";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.FilterBO, url, "ClaimsServiceLineReport.csv")
    }
  }
  //...................................................MovetoActive.......................................................................
  MovetoActive() {
    let url = "api/ClaimMaster/MovetoActive";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.ClaimMasterIds, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.ClaimMasterIds = [];
      this.claimsAllIdList = [];
      this.claimsSelectedList = [];
      this.isClaimsSelectedId = [];
      this.toastrService.success('Claim activated successfully!');
      this.getClaimsFilter();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);

    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
  //............................................................Move to archive.......................................................
  MovetoArchive() {
    let url = "api/ClaimMaster/MovetoArchive";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.ClaimMasterIds, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.ClaimMasterIds = [];
      this.claimsAllIdList = [];
      this.claimsSelectedList = [];
      this.isClaimsSelectedId = [];
      this.getClaimsFilter();
      this.toastrService.success('Claim archived successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  //............................................................RestoreActive...................................
  RestoreActive() {
    let url = "api/ClaimMaster/RestoreActiveClaim";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.ClaimMasterIds, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.ClaimMasterIds = [];
      this.claimsAllIdList = [];
      this.claimsSelectedList = [];
      this.isClaimsSelectedId = [];
      this.toastrService.success('Claim restored to active successfully!');
      this.getClaimsFilter();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  //............................................................reexport.......................................................
  reexport() {
    let url = "api/ClaimMaster/ReexportClaim";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.ClaimMasterIds, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.ClaimMasterIds = [];
      this.claimsAllIdList = [];
      this.claimsSelectedList = [];
      this.isClaimsSelectedId = [];
      this.toastrService.success('Claim Re-Exported successfully!');
      this.getClaimsFilter();

      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  //..........................................................newdates.............................................................
  newdates(event, type, name) {
    if (type == "inputchage") {
      if (name == 'filterstart') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchangeReturnall(event);
          this.ListBO.fromDate = val1;
        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchangeReturnall(event);
          this.ListBO.toDate = val1;
        }
      }

    }
    if (type == "datechagned") {
      if (name == 'filterstart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ListBO.fromDate = val1;
          this.global.claimsFromDate = val1;
        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ListBO.toDate = val1;
        }
      }

    }
  }
  //..................................................... Bulk claims Delete.........................................
  showClaimsDeletePopUp() {
    document.getElementById('openBulkDelete').click()
  }
  // .................................................DeleteMultipleClaims.................................................
  DeleteMultipleClaims() {
    let url = "api/ClaimProcess/deleteMultipleClaims"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.isClaimsSelectedId, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.toastrService.success('Claims Deleted successfully!');
      document.getElementById('openBulkDelete').click()
      this.claimsSelectedList = [];
      this.isClaimsSelectedId = [];
      this.ClaimMasterIds = [];
      this.getClaimsFilter();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  //.................................................EmailToClient....................................................
  getEmailToClient() {
    let EmailList: GenerateEmailInvoiceBo = JSON.parse(JSON.stringify(this.generateInvoicedetails));
    EmailList.claimMasterIds = this.isClaimsSelectedId;
    let url = "api/ClaimProcess/MailInvoices"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(EmailList, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success('Emailing in Progress!');
      this.getClaimsFilter();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  //..................................................ClearValues...........................................................
  ClearValues() {
    this.ListBO.dateFilterType = "fromdate";
    this.ListBO.pPClientId = "00000000-0000-0000-0000-000000000000";
    this.ListBO.groupId = "00000000-0000-0000-0000-000000000000";
    this.ListBO.payerId = "00000000-0000-0000-0000-000000000000";
    this.ListBO.employeeId = "00000000-0000-0000-0000-000000000000";
    this.ListBO.clientId = "00000000-0000-0000-0000-000000000000";
    this.ListBO.companyId = "00000000-0000-0000-0000-000000000000";
    this.batchList.clearingHouseId = "00000000-0000-0000-0000-000000000000"
    this.ListBO.fromDate = null;
    this.ListBO.toDate = null;
    this.ListBO.claimStatus = "";
    this.ListBO.underbilled = null;
    this.gridClaims.dataSource = [];
    this.ListBO.masterServiceId = null;
    this.isEnabledExcel = false;
    this.ListBO.resubmissionLid = "00000000-0000-0000-0000-000000000000";
    this.isClaimsSelectedId = [];
    this.ClaimMasterIds = [];
    this.claimsAllIdList = [];
    this.claimsSelectedList = [];
    this.gridClaims.height = 'auto';
    // this.ListBO=new GetClaimsListBO();
    this.gridClaims.clearFiltering();
    this.gridClaims.clearSorting();
  }
  //........................................................GenerateClaimsInvoiceList..........................................
  GenerateClaimsInvoiceList() {
    let invoiceList: GenerateEmailInvoiceBo = JSON.parse(JSON.stringify(this.generateInvoicedetails));
    invoiceList.claimMasterIds = this.isClaimsSelectedId;
    let url = "api/ClaimProcess/Getinvoices";
    this.CommonAPI.saveorUpdateFunctionFileSaver(invoiceList, url, "ClaimsInvoice.zip");
  }
  //.....................................DeleteClaim..........................................
  setClaimmasterIds(data) {
    this.claimids = data;
  }
  deleteClaim() {
    let param = new URLSearchParams()
    param.append("id", this.claimids.toString());
    let url = "api/ClaimProcess/deleteClaim?";
    this.CommonAPI.DeleteFunctionForGetHttp(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data): any => {
      this.toastrService.success("Claim deleted successfully!");
      document.getElementById("opendeleteclaim").click();
      this.claimsSelectedList = [];
      this.isClaimsSelectedId = [];
      this.ClaimMasterIds = [];
      this.getClaimsFilter();
    }, (err: any) => {
      let val: any = err;
      this.toastrService.error(val, 'Error');
    });
  }
  // for edit
  Claimsdatabind(data: any) {

    this.isListOptions.emit({
      isedited: true, claimMasterId: data.id,
      tabsChanges: this.claimsOptions.tabsChanges, is87IClaim: this.claimsOptions.is87IClaim,
      ClaimsfilterDetails: this.FilterBO, isClaimsViewEnable: true, ReadyColumns: this.ReadyJson,
      ActiveColumns: this.ActiveJson, ArchiveColumns: this.ArchiveJson, claimsStatusData: this.FilterBO.claimStatus,
      groupIds: this.FilterBO.groupId, PayorIds: this.FilterBO.payerId, masterServiceIds: this.FilterBO.masterServiceId,
      selectedGroupName: this.selectedGroupName, companyIds: this.FilterBO.companyId,
      isClaimAttachment:data.isClaimAttachment
    })
  }

  GenerateReport(List) {

    this.CreatedBatchList.fileName = List.fileName;
    this.CreatedBatchList.batchno = List.batchno;
    let currentTime = this.datePipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.ReportView = true;
    this.ReportHeader = "View 837";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("openCreate837Modal").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.environmentservice?.Environments?.BatchViewReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:batchno=" +
        this.CreatedBatchList.batchno +
        "&rp:filename=" +
        this.CreatedBatchList.fileName +
        "&rp:createdate=" +
        this.global.getDateTimeString(this.CreatedBatchList.invoice837P.file_Creation_Date) +

        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
     
      let embedReportId =  this.environmentservice?.Environments?.BatchViewReportId 
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }


  // ServiceDetailCsv: ServiceDetailCsvBo = new ServiceDetailCsvBo()
  // Export() {
  //   this.ServiceDetailCsv.serviceDetails=this.claimsexportlist
  //     this.Claimslistservice.GetServicelineExport(this.ServiceDetailCsv)
  //   setTimeout(() => {
  //     this.ClaimMasterIds = []
  //     this.claimsexportlist=[]
  //     this.getClaimsFilter();
  //   }, 1000);
  // }
  //................................................close837Modal.........................................................
  close837Modal() {
    document.getElementById("openCreate837Modal").click();
    this.ReportView = false;
  }



  //..................................MarkPaiddatechange.........................................................
  MarkPaiddatechange(event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.MarkServiceAsPaid.paidDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  //..................................MakeMarkServicePaid.........................................................
  MakeMarkServicePaid() {
    this.MarkServiceAsPaid = new MarkServiceAsPaidBO();
    this.MarkServiceAsPaid.paidDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();

  }
  //..................................onMarkPaidDateChanged.........................................................
  onMarkPaidDateChanged(event: IMyDateModel) {
    this.MarkServiceAsPaid.paidDate = event.formatted;
  }

  //..................................................MarkServicePaid.......................................
  MarkServicePaid() {
    let saveList: MarkServiceAsPaidBO = JSON.parse(JSON.stringify(this.MarkServiceAsPaid))
    saveList.paidAmount = 0
    saveList.claimMasterIds = this.ClaimMasterIds
    saveList.paidDate = (saveList.paidDate != null) ? this.global.getDateTimeString(saveList.paidDate) : null
    saveList.typeofpay = this.MarkServiceAsPaid.typeofpay;
    let url = "api/ClaimMaster/MarkAsPaid";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastrService.success("Payment details updated successfully!");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getClaimsFilter();
          document.getElementById("openMarkPaidModal").click();
        },
        (err: any) => {
          let val: any = err;
          this.toastrService.error(val, "Error");
          document.getElementById("openMarkPaidModal").click();
        }
      );
  }

// get Claim Attachment Details
getClaimAttachmentDetails(){
  let url ="api/ClaimMaster/GetAUCCoversheet"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimAttachmentIds,url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any)=>{
      this.UACLetterdata = data;
      this.global.coverLetterDetails=data[0];
       setTimeout(() => {
         this.isViewUACLetter=true;
         document.getElementById('UACModalOpen').click();
       }, 500);     
      },
     (err:any)=>{
         this.toastrService.error(err,'Error')
         setTimeout(() => {
           this.toastrService.clear();
         }, 6000);
     })
 }

// Close UAC Letter
closeUACLetter(){
 this.isViewUACLetter=false;
 this.isClaimAttachmets=false;
 this.claimAttachmentIds=[];

}
  clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridClaimsGrid', expectedColumns: this.ClaimListTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
}
